import React from 'react';
import { Glyphicon } from 'react-bootstrap';

const Spinner = () => {
    return <div style={{ textAlign: "center", marginTop: "13rem", marginBottom: "8rem" }}>
        <Glyphicon className="spinning" glyph="cog" style={{ fontSize: "30px", lineHeight: "14px", color: "#6c716c" }} />
    </div>
}

export default Spinner;